import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse } from '@/utils'
import { APIErrorResponse, DeleteQuotationResearchSpecie } from '@/types'

export const useDeleteQuotationResearchSpecie = (
  quotationId: number
): UseMutationResult<
  unknown,
  APIErrorResponse,
  DeleteQuotationResearchSpecie
> => {
  const client = useApiClient()

  return useMutation((params) =>
    client
      .delete<DeleteQuotationResearchSpecie>(
        `/quotations/${quotationId}/researches/${params.research_id}/species/${params.id}/`
      )
      .catch(unwrapErrorResponse)
  )
}
